import { render, staticRenderFns } from "./i18n.vue?vue&type=template&id=29be6622&scoped=true"
import script from "./i18n.vue?vue&type=script&lang=js"
export * from "./i18n.vue?vue&type=script&lang=js"
import style0 from "./i18n.vue?vue&type=style&index=0&id=29be6622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29be6622",
  null
  
)

export default component.exports